import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// -------------------------------------------------------------------
declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    // eslint-disable-next-line no-unused-vars
    gtag: (...args: any[]) => void; // Adjust the type as necessary
  }
}
export const useGAPageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search + location.hash,
      page_search: location.search,
      page_hash: location.hash,
    });
  }, [location]);
};
